import { Box, Grid, Link, DialogContent } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  candidateSearchAdvancedQuery,
  deleteJobFromCareerBuilder,
  deleteJobFromJobBoard,
  deleteJobFromTechFetch,
  getJobDetailsAtJobTarget,
  IJob,
  IJobCandidateInteraction,
  updateAddToCareerPage,
  deleteJobFromCWJobs,
  ICWJobsJobPostDTO,
  getJobBoardsByName,
  IJobBoard,
  getCurrentUserTeams,
} from 'wisestep-api';
import {
  WsButton,
  WsColors,
  WsDataTable,
  WsIconDelete,
  WsIconPublish,
  WsTypography,
  Notification,
  WsDialog,
  WsTypoVariants,
  WsDialogSize,
  IUserDTO,
} from 'wisestep-base';

import NoDataFoundCard from '../../../../../../components/noDataFoundCard';
import { useUserContext } from '../../../../../../context';
import { INotification } from '../../../../../../utils/NotificationStore';

import { CandidateJobBoardCountQuery } from './CandidateJobBoardCountQuery';

interface PublishedProps {
  job: IJob;
}

const Published = ({ job }: PublishedProps) => {
  const navigate = useNavigate();

  const [notify, setNotify] = useState<boolean>(false);
  const [candidatesData, setCandidatesData] = useState<IJobCandidateInteraction[]>([]);
  const [openCareersPagePopup, setOpenCareersPagePopup] = useState<boolean>(false);
  let tableData: Record<string, unknown>[] = [];
  const displayedJobBoardsForOldData: string[] = [];

  const [deletePublishedJob, setDeletePublishedJob] = useState<boolean>(false);

  const [notificationObject, setNotificationObject] = useState<INotification>();

  const navigateToPublish = () => navigate(`/jobs/${job.id}/publish`);

  useEffect(() => {
    const fetchCandidates = async () => {
      const response = await candidateSearchAdvancedQuery(CandidateJobBoardCountQuery);
      const jobs = response.data;
      setCandidatesData(jobs);
    };
    fetchCandidates();
  }, []);

  const showJobDeletedMessage = () => {
    setNotify(true);
    setNotificationObject({
      message: 'Your Job Will Be Deleted from JobBoard',
      type: 'success',
    });
  };

  const deleteItemFromTable = (jobBoardName: string) => {
    tableData = tableData.filter((item) => item.PublishedOn != jobBoardName);
    setJobPostingData(tableData);
  };

  const handleDeleteJobFromJobBoard = (jobBoardName: string) => {
    if (jobBoardName === 'CareersPage') {
      setOpenCareersPagePopup(true);
    } else if (jobBoardName === 'TechFetch') {
      handleDeleteJobFromTechFetch();
    } else if (jobBoardName === 'JobTarget') {
      manageJobTargetJob();
    } else if (jobBoardName === 'CareerBuilder') {
      handleDeleteJobFromCareerBuilder();
    } else if (jobBoardName === 'CWJobs') {
      handleDeleteFromCWJobs();
    } else {
      handleDeleteFromOtherJobBoards(jobBoardName);
    }
  };

  const manageJobTargetJob = async () => {
    if (job.id) {
      const jobTargetDetails = await getJobDetailsAtJobTarget(job.id);
      const jobTargetURL = jobTargetDetails.data.job_manage_url;
      window.open(jobTargetURL, '_blank');
    }
  };

  const handleDeleteFromCWJobs = async () => {
    if (job.paidJobBoardAccount && job.id) {
      const cwjobBoardAccount = JSON.parse(job.paidJobBoardAccount);
      const payload: ICWJobsJobPostDTO = {
        jobIds: [job.id],
        jobBoardId: cwjobBoardAccount.jobBoardId,
      };
      await deleteJobFromCWJobs(payload);
      showJobDeletedMessage();
      deleteItemFromTable('CWJobs');
    }
  };

  const handleDeleteJobFromTechFetch = async () => {
    if (job.paidJobBoardAccount && job.id) {
      const techfetchAccount = JSON.parse(job.paidJobBoardAccount);
      await deleteJobFromTechFetch(job.id, techfetchAccount.JobBoardAccountEmail);
      showJobDeletedMessage();
      deleteItemFromTable('TechFetch');
    }
  };

  const handleDeleteJobFromCareerBuilder = async () => {
    if (job.id) {
      await deleteJobFromCareerBuilder(job.id);
      showJobDeletedMessage();
      deleteItemFromTable('CareerBuilder');
    }
  };
  const handleDeleteFromOtherJobBoards = async (jobBoardName: string) => {
    if (job.id) {
      await deleteJobFromJobBoard(jobBoardName, job.id);
      showJobDeletedMessage();
      deleteItemFromTable(jobBoardName);
    }
  };

  const confirmDeleteFromCareersPage = async () => {
    if (job.id) {
      await updateAddToCareerPage(job.id, false);
      setOpenCareersPagePopup(false);
      showJobDeletedMessage();
      tableData = [];
      setJobPostingData(tableData);
    }
  };

  const getLink = (jobBoardName: string) => {
    if (jobBoardName == 'Monster' && job.monsterJobId)
      return (
        <Link
          color={WsColors.TheBlues500}
          href="{`http://jobview.monster.com/getjob.aspx?jobid= ${job.monsterJobId}`}"
        >
          {`http://jobview.monster.com/getjob.aspx?jobid= ${job.monsterJobId}`}
        </Link>
      );
    else if (jobBoardName == 'JobTarget') {
      return <WsButton onClick={manageJobTargetJob}>Manage Job</WsButton>;
    } else {
      return <WsTypography>Not Shared By Job Board</WsTypography>;
    }
  };
  const loggedInUser = useUserContext().userDTO as IUserDTO;

  useEffect(() => {
    (async () => {
      if (job.id) {
        let emails: string[] = loggedInUser?.email ? [loggedInUser.email] : [];
        if (Array.isArray(loggedInUser.oldEmails) && loggedInUser.oldEmails) {
          emails = [...emails, ...loggedInUser.oldEmails];
        }

        const teamReqRepsonse = await getCurrentUserTeams();
        const teamIds = [...teamReqRepsonse.data.ownsTeams, ...teamReqRepsonse.data.belongsToTeams];
        if (job.team?.id && teamIds.indexOf(job.team.id) > -1) {
          setDeletePublishedJob(true);
        }
        if (job.createdBy && emails.indexOf(job.createdBy) > -1) {
          setDeletePublishedJob(true);
        }
      }
    })();
  }, [job.createdBy, job.id, job?.team?.id, loggedInUser.email, loggedInUser.oldEmails]);

  const getCandidatesAppliedCount = (jobBoardName) => {
    let count = 0;
    candidatesData.forEach((candidate) => {
      if (candidate.source == jobBoardName) {
        count = count + 1;
      }
    });
    return count == 0 ? 'Not Available' : count;
  };

  const [sharedCredits, setSharedCredits] = useState({});

  const addTableData = async (jobBoardName: string, createdBy?: string) => {
    let action = <></>;
    if (jobBoardName) {
      if (
        sharedCredits[jobBoardName] > 0 ||
        (!Object.prototype.hasOwnProperty.call(sharedCredits, jobBoardName) && deletePublishedJob)
      ) {
        action = (
          <IconButton onClick={() => handleDeleteJobFromJobBoard(jobBoardName ?? '')}>
            <WsIconDelete />
          </IconButton>
        );
      }
    }
    tableData.push({
      PublishedOn: jobBoardName,
      publishedBy: createdBy,
      JobLInk: getLink(jobBoardName ?? ''),
      CandidatesApplied: getCandidatesAppliedCount(jobBoardName ?? ''),
      Actions: action,
    });
    setJobPostingData(tableData);
  };

  const sharedUserCount = (jobBoard: IJobBoard) => {
    return jobBoard.jobBoardSharedUsers
      ?.filter((jobBoardSharedUser) => jobBoardSharedUser.email === loggedInUser.email)
      .reduce((count, jobBoardSharedUser) => count + jobBoardSharedUser.maxPostingsPerMonth, 0);
  };

  const getJobBoardAvailCredits = async () => {
    const jobBoards = await getJobBoardsByName(
      'Monster,Dice,TechFetch,CareerBuilder,CWJobs,MonsterUK'
    );
    const credits = {};
    jobBoards.data.forEach((jobBoardResponse) => {
      credits[jobBoardResponse.jobBoardName] = sharedUserCount(jobBoardResponse);
    });
    setSharedCredits(credits);
  };

  useEffect(() => {
    getJobBoardAvailCredits();
  }, []);

  useEffect(() => {
    if (job.postedOnJobBoards || job.jobBoardPosting) {
      job.jobBoardPosting?.forEach((jobBoardPostingItem) => {
        displayedJobBoardsForOldData.push(jobBoardPostingItem.jobBoardName ?? '');
        addTableData(jobBoardPostingItem.jobBoardName ?? '', jobBoardPostingItem.createdBy ?? '');
      });
      job.postedOnJobBoards
        ?.filter((jobBoardName) => !displayedJobBoardsForOldData.includes(jobBoardName))
        .forEach((jobBoardName) => {
          addTableData(jobBoardName);
        });
    }
  }, [sharedCredits, deletePublishedJob]);

  const [jobPostingData, setJobPostingData] = useState(tableData);
  const columns = [
    { Header: 'Published on', accessor: 'PublishedOn' },
    { Header: 'Published By', accessor: 'publishedBy' },
    { Header: 'Job LInk', accessor: 'JobLInk' },
    { Header: 'Candidates Applied', accessor: 'CandidatesApplied' },
    { Header: 'Actions', accessor: 'Actions' },
  ];

  return (
    <>
      <Box>
        <Grid item container justifyContent="flex-end">
          <WsButton
            variant="text"
            size="large"
            startIcon={<WsIconPublish color={WsColors.TheBlues500} />}
            onClick={navigateToPublish}
          >
            Publish more
          </WsButton>
        </Grid>
        {jobPostingData.length > 0 ? (
          <Box py={2}>
            <WsDataTable
              columns={columns}
              data={jobPostingData}
              selectable={false}
              headless={false}
            />
          </Box>
        ) : (
          <NoDataFoundCard text="Job Not yet published" />
        )}
      </Box>
      <Notification
        vertical="top"
        horizontal="right"
        autoHideDuration={3000}
        notify={notify}
        notificationObject={notificationObject}
      />
      <WsDialog openDialog={openCareersPagePopup} size={WsDialogSize.MEDIUM}>
        <DialogContent>
          <Grid container justifyContent="center" padding={4}>
            <Grid item xs={12}>
              <Grid>
                <WsTypography variant={WsTypoVariants.TITLE}>
                  Are you sure you want to delete this Job?
                </WsTypography>
              </Grid>
              <Grid pt={2}>
                <WsTypography variant={WsTypoVariants.BODY2}>
                  This job posting will be removed from all the job boards along with career pages.
                  Do you wish to continue?
                </WsTypography>
              </Grid>
            </Grid>

            <Grid item pt={4}>
              <WsButton onClick={() => setOpenCareersPagePopup(false)}>Cancel</WsButton>
            </Grid>
            <Grid item pt={4} pl={2}>
              <WsButton onClick={confirmDeleteFromCareersPage}>Delete</WsButton>
            </Grid>
          </Grid>
        </DialogContent>
      </WsDialog>
    </>
  );
};

export default Published;
